module.exports = __webpack_public_path__ + "img/crossriver.fdd089e4.png";